/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { AngularFireAction, DatabaseSnapshot } from '@angular/fire/compat/database';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { FancyAction } from '../base/FancyAction';
import { FancyFirebaseList } from '../base/FancyFirebaseList';
import { FancyFragmenter, Fragment, RefSourceType } from '../base/FancyFragmenter';
import { IFancyIdJoin } from '../base/FancyIdJoin';
import { AngularLandConnection, RefOrObservable } from '../base/interfaces';

/**
 * The fragmenter being built and driven by a FancyJoin creates a certain interesting problem.
 * Sometimes you don't actually have a baseList to drive it, for example, the
 * [[TimelineTicketList]] and [[ConstraintList]]. Since the index is an index, we
 * don't really actually care about the index data and just need it to drive the fragmenter.
 * Thus, this can be the dumping ground for that.
 */

export class FancyListIndexDump extends FancyFirebaseList<any, FancyAction> implements IFancyIdJoin {
	constructor(angularLand: AngularLandConnection, path: RefOrObservable, fancyJoins?: any) {
		//fix any's
		super(angularLand, path, FancyAction, fancyJoins);
	}

	public $$added(action: AngularFireAction<DatabaseSnapshot<any>>) {
		const thing = Object.assign(action.payload.val());
		thing.$id = action.payload.key;
		return thing;
	}
	public $$updated(child, action: AngularFireAction<DatabaseSnapshot<any>>) {
		Object.assign(child, action.payload.val());
	}

	//put in interface so you can explicitly say you're doing this
	public applyJoinData(baseKey: string, child, otherChild: any) {
		child.stuff = otherChild;
	}
	public getDataForKey(baseKey: string, child) {
		return child.$id;
	}
}

export class FancyListIndexFragmenter extends FancyFragmenter {
	public getChildRef(id: string) {
		const ids = id.split(',');

		if (this.refSourceType === RefSourceType.StaticRef) {
			return of(this.baseRef.child(ids[0]).child(ids[1]));
		} else {
			throw new Error('FancyListIndexFragment does not support observable input');
		}
	}
}
